<template>
	<div class="course">
		<!-- 搜索 -->
		<div v-show="!isto">
			<div class="search-bar">
				<div class="search-left">
					<el-input v-model="queryParams.courseName" placeholder="课程名称" style="width:200px;margin-right:10px"
						@input="handleSearchInput" clearable></el-input>
					<el-select v-if="toAdmin" v-model="isAdmin" placeholder="请选择查询类型"
						style="width:150px;margin-right:10px" clearable @change="fetchData">
						<el-option v-for="item in adminlist" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<!-- 年级：下拉框 -->
					<el-select v-model="queryParams.grade" placeholder="请选择年级" style="width:150px;margin-right:10px"
						clearable @change="foGrade">
						<el-option v-for="item in gradeList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select v-model="queryParams.subject" placeholder="请选择学科" style="width:150px;margin-right:10px"
						clearable @change="foSubject">
						<el-option v-for="item in forSubjectList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<!-- <el-button type="primary" icon="el-icon-search" @click="fetchData">搜索</el-button> -->
				</div>
				<el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增课程</el-button>
			</div>

			<!-- 表格 -->
			<el-table :data="tableData" border style="width:100%;margin-top:20px">
				<el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
				<el-table-column prop="courseName" label="标准课程名称" width="200" align="center"></el-table-column>
				<el-table-column prop="grade" label="年级" width="80" align="center">
					<template slot-scope="scope">
						{{ gradeName(scope.row.grade)}}

					</template>

				</el-table-column>
				<el-table-column prop="subject" label="学科" width="80" align="center">
					<template slot-scope="scope">
						{{ subjectName(scope.row.subject)}}

					</template>
				</el-table-column>
				<el-table-column prop="expireTime" label="配置状态" width="80" align="center">
					<template slot-scope="scope">{{scope.row.hasConfig?"已配置":"未配置"}}</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="80" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.status===0?'success':'danger'">
							{{ scope.row.status===0?'启用':'禁用' }}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="expireTime" label="授权截至时间" width="180" align="center">
					<template slot-scope="scope">{{ formatTime(scope.row.expireTime) }}</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180" align="center">
					<template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
				</el-table-column>
				<el-table-column label="操作" max-width="200" align="center">
					<template slot-scope="scope">
						<div
							v-if="(scope.row.orgId==orgId&&scope.row.userId==userId&&scope.row.platformFlag==userType)||(userType==1&&scope.row.orgId==0)">
							<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
							<el-button size="mini" @click="handleEdits(scope.row)">配置</el-button>
							<el-button v-if="scope.row.status===0" size="mini" type="warning"
								@click="handleStatus(scope.row)">
								禁用
							</el-button>
							<el-button v-if="scope.row.status===1" size="mini" type="success"
								@click="handleStatus(scope.row)">
								启用
							</el-button>
							<el-button size="mini" v-if="scope.row.status===1" type="danger"
								@click="handleDelete(scope.row)">删除</el-button>
						</div>
						<div v-else>
							<el-button size="mini" @click="vimSave(scope.row)">查看</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.pageNum" :page-sizes="[10,20,50]" :page-size="queryParams.pageSize"
				layout="total,sizes,prev,pager,next,jumper" :total="total"
				style="margin-top:20px;text-align:right"></el-pagination>
		</div>

		<!-- 弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="650px">
			<el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
				<el-form-item label="课程名称" prop="courseName">
					<el-input v-model="form.courseName" placeholder="请输入课程名称"></el-input>
				</el-form-item>
				<el-form-item label="年级" prop="grade">
					<el-select v-model="form.grade" @change="toSubject" placeholder="请选择年级" style="width:100%">
						<el-option v-for="item in gradeList.filter(v=>v.value!==0)" :key="item.value"
							:label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="学科" prop="subject">
					<el-select v-model="form.subject" :disabled="!form.grade" placeholder="请选择年级" style="width:100%">
						<el-option v-for="item in subjectList.filter(v=>v.value!=-1)" :key="item.value"
							:label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="授权过期时间" prop="expireTime">
					<el-date-picker v-model="form.expireTime" type="datetime" placeholder="选择过期时间" style="width:100%"
						value-format="timestamp">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="页面" prop="customPageId">
					<el-radio-group v-model="form.customPageId">
						<!-- <el-radio :label="0">默认</el-radio> -->
						<el-radio :label="1" :value="1">配置</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="dialogVisible=false">取消</el-button>
				<el-button type="primary" @click="handleSubmit">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		forGradeList,
		forSubjectList
	} from "@/js/standard.js";
	export default {
		name: 'Course',
		components: {
			// PageConfigAdmin
		},
		data() {
			return {
				tableData: [],
				total: 0,
				workflowList: [],
				gradeList: [], // 年级下拉数据
				schoolList: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					courseName: '',
					grade: 0,
					subject: "-1",

				},
				userId: localStorage.getItem("userId"),
				orgId: localStorage.getItem("orgId"),
				userType: localStorage.getItem("userType"),
				isAdmin: 0,
				courseClassId: 0,
				dialogVisible: false,
				dialogTitle: '',
				subjectList: [],
				form: {
					id: null,
					courseName: '',
					grade: '',
					subject: '',
					status: 1,
					customPageId: 1,
					schoolId: localStorage.getItem("orgId"), // 学校ID
					expireTime: null // 过期时间戳
				},
				isto: false,
				rules: {
					courseName: [{
						required: true,
						message: '请输入课程名称',
						trigger: 'blur'
					}],
					expireTime: [{
						required: true,
						message: '请输入过期时间',
						trigger: 'blur'
					}],
					grade: [{
						required: true,
						message: '请选择年级',
						trigger: 'change'
					}],
					subject: [{
						required: true,
						message: '请输入学科',
						trigger: 'blur'
					}],
					classInfo: [],

				},
				adminlist: [{
						value: 0,
						label: "仅自己"
					},
					{
						value: 1,
						label: "全校"
					},
				],
				toAdmin: false,
				subjectLists: [],
				forSubjectList:[],
			}
		},

		methods: {
			toSubject(val) {

				if (this.userType == 2) {
					var stageCode = val < 7 ? 1 : val < 10 ? 2 : 3
					this.subjectList = this.subjectLists.filter(v => v.stageCode == stageCode)
					this.form.subject = ''
				}

			},
			async info() {
				try {
					if (localStorage.getItem('userType') == 2) {
						let str = localStorage.getItem('userInfo')

						let list = JSON.parse(str)
						console.log('list', localStorage.getItem('userInfo'))
						this.subjectLists = JSON.parse(localStorage.getItem('subjectList'))
						this.toAdmin = list?.filter(v => v.roleType == 2).length > 0 ? true : false
					} else {
						this.toAdmin = false
					}

				} catch (error) {
					this.toAdmin = false
				}
			},

			handleSearchInput() {
				// 清除之前的定时器（防抖）
				clearTimeout(this.searchTimer)

				// 300ms 内不重复输入，才发送请求
				this.searchTimer = setTimeout(() => {

					this.queryParams.pageNum = 1 // 回到第一页
					this.fetchData() // 调用搜索接口
				}, 300)
			},
			foGrade(val) {
				this.queryParams.pageNum = 1
				this.queryParams.grade = val
				this.fetchData()
			},
			foSubject(val) {
				this.queryParams.pageNum = 1
				this.queryParams.subject = val
				this.fetchData()
			},
			handleEdits(row) {
				// console.log(row)
				// return 
				this.classInfo = row
				if (localStorage.getItem('userType') == 2) {
					this.$router.push({
						path: '/teacher/PageConfigAdmin',
						query: {
							classInfo: this.classInfo
						}
					})
				} else {
					this.$router.push({
						path: '/admin/PageConfigAdmin',
						query: {
							classInfo: this.classInfo
						}
					})
				}
			},
			vimSave(row) {
				this.classInfo = row
				if (localStorage.getItem('userType') == 2) {
					this.$router.push({
						path: '/teacher/PageConfigAdmin',
						query: {
							classInfo: this.classInfo,
							vimSave: true,
						}
					})
				} else {
					this.$router.push({
						path: '/admin/PageConfigAdmin',
						query: {
							classInfo: this.classInfo,
							vimSave: true,
						}
					})
				}

			},
			subjectName(value) {
				return this.subjectList.filter(v => v.value == value)[0].label || ''
			},
			formatTime(t) {
				if (!t) return ''
				return new Date(t).toLocaleString()
			},
			gradeName(value) {
				return this.gradeList.filter(v => v.value == value)[0].label || ''
			},
			// 获取年级列表（接口）
			async fetchGradeList() {
				if (this.userType == 2) {
					await this.schoolGradeList()
					await this.schoolSubject()
				} else if (this.userType == 1) {
					this.subjectList = await forSubjectList()
					this.gradeList = await forGradeList()
				}
			},
			async schoolSubject() {
				try {
					let list = JSON.parse(localStorage.getItem('subjectList'))
					this.subjectList=[{value:'-1',label:"全部学科"},...list]
					this.forSubjectList=this.subjectList
				} catch (err) {
					this.subjectList = []
				}
			},
			async schoolGradeList() {
				try {
					let res = await this.API.get(this.API.school.getSchoolGrad, {
						schoolId: localStorage.getItem('orgId')
					});
					console.log(res.data.data)
					
					let list = res.data.data?.map(v=>{
						
						return {
							...v,
							value:v.grade,
							label:v.gradeName
						}
					})
					this.gradeList=[{value:0,label:"全部年级"},...list]
				} catch (err) {
					this.gradeList = []
				}
			},
			async fetchWorkflowList() {
				const res = await this.API.get(this.API.admin.getWorkflowList, {
					pageNum: 1,
					pageSize: 100
				})
				this.workflowList = res.data.data.records || []
			},
			async getSchoolList(schoolName) {
				// if (!schoolName) {
				//   this.schoolList = [];
				//   return;
				// }
				try {
					const res = await this.API.get(this.API.admin.getSchoolList, {
						pageNum: 1,
						pageSize: 100,
						schoolName: schoolName
					});
					this.schoolList = res.data.data.records || [];
				} catch (e) {
					this.schoolList = [];
				}
			},
			async fetchData() {
				const res = await this.API.get(this.API.school.getCourseaOrgList, {
					isAdmin: this.isAdmin,
					pageNum: this.queryParams.pageNum,
					pageSize: this.queryParams.pageSize,
					schoolId: localStorage.getItem('orgId'),
					courseName: this.queryParams.courseName,
					grade: this.queryParams.grade == 0 ? "" : this.queryParams.grade,
					subject: this.queryParams.subject == -1 ? '' : this.queryParams.subject,
				})
				this.tableData = res.data.data.records || []
				this.total = res.data.data.total || 0
			},

			handleAdd() {
				this.getSchoolList()
				this.dialogTitle = '新增课程'
				this.form = {
					id: null,
					courseName: '',
					grade: '',
					subject: '',
					schoolId: localStorage.getItem("orgId"),
					orgId: localStorage.getItem("orgId"),
					status: 1,
					customPageId: 1
				}
				this.dialogVisible = true
			},

			handleEdit(row) {
				console.log(row)
				// this.getSchoolList()
				this.dialogTitle = '编辑课程'
				this.form = {
					...row
				}
				this.dialogVisible = true
			},

			async handleSubmit() {
				
				this.$refs.formRef.validate(async valid => {
					if (!valid) return
					// console.log('this.form',this.form)
					// return
					if (this.form.id) {
						await this.API.put(this.API.admin.putCourseUpdate, this.form)
						this.$message.success('修改成功')
					} else {
						await this.API.post(this.API.admin.postCourseAdd, this.form)
						this.$message.success('新增成功')
					}
					this.dialogVisible = false
					this.fetchData()
				})
			},

			async handleStatus(row) {

				const newStatus = row.status === 0 ? 1 : 0
				try {
					let res = await this.API.put(this.API.admin.putCourseStatus + row.id + "?status=" + newStatus)

					if (res.data.code == 500) {
						this.$message.error(res.data.msg)
					} else {
						this.fetchData()
						this.$message.success('状态已更新')
					}
				} catch (error) {

				}

			},

			async handleDelete(row) {
				this.$confirm('确定删除该课程？', '提示', {
					type: 'warning'
				}).then(async () => {
					await this.API.deleted(this.API.admin.deletedCourseRemove + row.id)

					this.fetchData()
				}).catch(() => {})
			},

			handleSizeChange(val) {
				this.queryParams.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.queryParams.pageNum = val
				this.fetchData()
			}
		},
		created() {

			this.fetchData()
			this.fetchWorkflowList()
			this.fetchGradeList() // 加载年级
			this.info()

		}
	}
</script>

<style scoped>
	.course {
		padding: 20px;
		background: #fff;
	}

	.search-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.search-left {
		display: flex;
		align-items: center;
	}
</style>